// extracted by mini-css-extract-plugin
module.exports = {"root":"R5KAC__root","legacyStyle":"_1E4XA__legacyStyle","commentScroll":"_1TtnP__commentScroll","chatForm":"_3uvyQ__chatForm","chatSubmitBtn":"_2LOOA__chatSubmitBtn"};